import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';

export default function SearchCard({ anchorRef, close }) {
  const [query, setQuery] = useState('')
  const [showDate, setShowDate] = useState(false)
  const [checkLater, setCheckLater] = useState(false)
  const [checkIn, setCheckIn] = useState('')
  const [checkOut, setCheckOut] = useState('')
  const [showGuests, setShowGuests] = useState(false)
  const [adults, setAdults] = useState(1)
  const [children, setChildren] = useState(0)
  const [visible, setVisible] = useState(false)
  const cardRef = useRef(null)
  const navigate = useNavigate()

  // Inchide cardul daca se da click in afara
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        cardRef.current &&
        !cardRef.current.contains(e.target) &&
        anchorRef.current &&
        !anchorRef.current.contains(e.target)
      ) {
        close()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [close, anchorRef])

  // Aparitia progresiva a cardului
  useEffect(() => {
    const timer = requestAnimationFrame(() => setVisible(true))
    return () => cancelAnimationFrame(timer)
  }, [])

  useEffect(() => {
    if (query.length >= 2) setShowDate(true)
    else setShowDate(false)
  }, [query])

  useEffect(() => {
    if ((checkIn && checkOut) || checkLater) setShowGuests(true)
    else setShowGuests(false)
  }, [checkIn, checkOut, checkLater])

  const handleSearch = () => {
    const params = new URLSearchParams({
      query,
      checkIn: checkLater ? '' : checkIn,
      checkOut: checkLater ? '' : checkOut,
      adults,
      children
    }).toString()

    navigate(`/search?${params}`)
    close()
  }

  return (
    <div ref={cardRef} className={`search-card ${visible ? 'visible' : ''}`}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Cauta judet, regiune sau nume..."
        className="search-input"
      />

      {showDate && (
        <div className="date-group">
          <input
            type="date"
            value={checkIn}
            onChange={(e) => setCheckIn(e.target.value)}
            className="date-input"
          />
          <input
            type="date"
            value={checkOut}
            onChange={(e) => setCheckOut(e.target.value)}
            className="date-input"
          />
          <label className="check-later">
            <input
              type="checkbox"
              checked={checkLater}
              onChange={() => setCheckLater(!checkLater)}
            />
            Mai tarziu
          </label>
        </div>
      )}

      {showGuests && (
        <div className="guests-group">
          <input
            type="number"
            min={1}
            value={adults}
            onChange={(e) => setAdults(e.target.value)}
            placeholder="Adulti"
            className="guest-input"
          />
          <input
            type="number"
            min={0}
            value={children}
            onChange={(e) => setChildren(e.target.value)}
            placeholder="Copii"
            className="guest-input"
          />
        </div>
      )}

      <div className="buttons-group">
        <button
          onClick={() => navigate('/advanced-search')}
          className="advanced-button"
        >
          Cautare Avansata
        </button>
        <button onClick={handleSearch} className="search-button">Cauta</button>
      </div>


      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600&display=swap');

        .search-card {
          position: absolute;
          top: 110%;
          left: 50%;
          transform: translateX(-50%) translateY(-20px);
          min-width: 280px;
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          z-index: 100;
          font-family: 'Sora', sans-serif;
          opacity: 0;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }

        .search-card.visible {
          transform: translateX(-50%) translateY(0);
          opacity: 1;
        }

        .search-input, .date-input, .guest-input {
          padding: 0.4rem 0.6rem;
          border-radius: 8px;
          border: none;
          font-size: 0.85rem;
          color: #dd4124;
          background: rgba(0, 109, 119, 0.2);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          outline: none;
        }

        .search-input::placeholder,
        .date-input::placeholder,
        .guest-input::placeholder {
          color: #dd4124;
          opacity: 0.7;
        }

        .date-group {
          display: flex;
          gap: 0.4rem;
          align-items: center;
        }

        .check-later {
          font-size: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.25rem;
          color: #dd4124;
        }

        .guests-group {
          display: flex;
          gap: 0.4rem;
        }

        .buttons-group {
          display: flex;
          gap: 0.4rem;
          margin-top: 0.3rem;
        }

        .search-button, .advanced-button {
          flex: 1;
          padding: 0.4rem 0.6rem;
          border-radius: 8px;
          cursor: pointer;
          background: rgba(0, 109, 119, 0.3);
          color: #dd4124;
          font-weight: 500;
          border: none;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          font-family: 'Sora', sans-serif;
          font-size: 0.80rem;
          white-space: nowrap;
          outline: none;
        }

        /* Mobile first */
        @media (min-width: 768px) {
          .search-card {
            min-width: 320px;
            gap: 0.5rem;
          }
          .search-input, .date-input, .guest-input, .search-button, .advanced-button {
            font-size: 0.9rem;
            padding: 0.45rem 0.7rem;
          }
        }
      `}</style>
    </div>
  )
}
